import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchPublicGoalsArgs } from '../api/types/user.types';

import { fetchPublicGoals } from '../api/users.api';

export const goalsQueryKeys = createQueryKeys('goals', {
  fetchInfiniteGoals: ({ filters, locale }: FetchPublicGoalsArgs) => ({
    queryFn: (context) =>
      fetchPublicGoals({
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
        locale,
      }),
    queryKey: [filters],
  }),
});
